import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { TimeClockCircleAlternate as Svg } from './svgs/TimeClockCircleAlternate.svg';

export const TimeClockCircleAlternate = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
